import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import RoversRangersService from '../services/RoversRangersService';
import RoversRangersSearch from '../records/RoversRangersSearch';

const RoversRangersActions = {

    async loadFromParams(params) {
        let search = await RoversRangersSearch.deserialize(params);

        return this.load(search);
    },

    load (search) {
        AppDispatcher.dispatch({
            search,
            actionType: ActionTypes.ROVERSRANGERS_SEARCH_LOADED
        });
        return search;
    },

    async search (search) {

        AppDispatcher.dispatch({
            actionType: ActionTypes.ROVERSRANGERS_SEARCH_STARTED,
            search
        });

        try {
            const result = await RoversRangersService.search(search);

            AppDispatcher.dispatch({
                actionType: ActionTypes.ROVERSRANGERS_SEARCH_FINISHED,
                search,
                searchResults: result
            });

            return result;
        } catch (error) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.ROVERSRANGERS_SEARCH_FAILED,
                search,
                error
            });

            throw error;
        }
    },

    selectTicket (fare) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ROVERSRANGERS_TICKET_SELECTED,
            fare
        });
    },

    changePassengers (pax) {
        AppDispatcher.dispatch({
            pax,
            actionType: ActionTypes.ROVERSRANGERS_TICKET_PASSENGERS_CHANGED
        });
    }
};

export default RoversRangersActions;
